module.exports = __webpack_public_path__ + "img/control_centerup.0de82105.png";